import { connect } from 'react-redux';
import { compose } from 'recompose';

import { filterOrders } from 'redux/modules/queued/effects';
import { getFilters } from 'redux/modules/queued/selectors';

import ShipperOrderTableHeader from './component';

const enhance = compose(
  connect(
    (state) => ({
      filters: getFilters(state),
    }),
    { filterOrders }
  )
);

export default enhance(ShipperOrderTableHeader);
